import { flip, offset, shift } from "@floating-ui/react";
import HoverTooltip from "components/elements/Tooltips/HoverTooltip";
import TooltipArrow from "components/elements/Tooltips/TooltipArrow";
import { sideNavTooltipClassName } from "components/layouts/elements/SideNav/SideNavTooltip";

/**
 * A short label on a small control, styled to match the side nav tooltips,
 * with a point that follows the tooltip if it flips to the other side. Used by
 * the toolbar and by list rows, which differ only in how long they wait.
 */
export default function ArrowTooltip(
  p: Readonly<{
    label: string;
    placement?: "top" | "bottom";
    /** Milliseconds to wait before opening */
    openDelay: number;
    isDisabled?: boolean;
    children: React.JSX.Element;
  }>,
) {
  return (
    <HoverTooltip
      className="flex"
      placement={p.placement ?? "top"}
      middleware={[offset(10), flip(), shift({ padding: 8 })]}
      hoverOptions={{
        delay: { open: p.openDelay, close: 100 },
        move: false,
        enabled: !p.isDisabled,
      }}
      tooltipClassName={sideNavTooltipClassName}
      customTooltipContent={(placement) => (
        <>
          <TooltipArrow placement={placement} />
          {p.label}
        </>
      )}
    >
      {p.children}
    </HoverTooltip>
  );
}
